import { render, staticRenderFns } from "./applyMessage.vue?vue&type=template&id=d06ec932&scoped=true&"
import script from "./applyMessage.vue?vue&type=script&lang=js&"
export * from "./applyMessage.vue?vue&type=script&lang=js&"
import style0 from "./applyMessage.vue?vue&type=style&index=0&id=d06ec932&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06ec932",
  null
  
)

export default component.exports